// ISO2 country code -> [latitude, longitude] approximate centroids.
// Used to place live-threat markers on an equirectangular world map.
export const COUNTRY_CENTROIDS = {
  US: [39.8, -98.6], CA: [56.1, -106.3], MX: [23.6, -102.5], BR: [-14.2, -51.9],
  AR: [-38.4, -63.6], CL: [-35.7, -71.5], CO: [4.6, -74.3], PE: [-9.2, -75.0],
  VE: [6.4, -66.6], EC: [-1.8, -78.2], BO: [-16.3, -63.6], PY: [-23.4, -58.4],
  UY: [-32.5, -55.8], GT: [15.8, -90.2], CR: [9.7, -83.8], PA: [8.5, -80.8],
  DO: [18.7, -70.2], CU: [21.5, -77.8], JM: [18.1, -77.3], HN: [15.2, -86.2],
  GB: [55.4, -3.4], IE: [53.4, -8.2], FR: [46.2, 2.2], DE: [51.2, 10.5],
  ES: [40.5, -3.7], PT: [39.4, -8.2], IT: [41.9, 12.6], NL: [52.1, 5.3],
  BE: [50.5, 4.5], CH: [46.8, 8.2], AT: [47.5, 14.6], SE: [60.1, 18.6],
  NO: [60.5, 8.5], FI: [61.9, 25.7], DK: [56.3, 9.5], PL: [51.9, 19.1],
  CZ: [49.8, 15.5], SK: [48.7, 19.7], HU: [47.2, 19.5], RO: [45.9, 24.9],
  BG: [42.7, 25.5], GR: [39.1, 21.8], HR: [45.1, 15.2], RS: [44.0, 21.0],
  UA: [48.4, 31.2], RU: [61.5, 105.3], TR: [38.9, 35.2], BY: [53.7, 27.9],
  LT: [55.2, 23.9], LV: [56.9, 24.6], EE: [58.6, 25.0], SI: [46.2, 14.8],
  IS: [64.9, -19.0], LU: [49.8, 6.1],
  CN: [35.9, 104.2], JP: [36.2, 138.3], KR: [35.9, 127.8], IN: [20.6, 78.9],
  PK: [30.4, 69.3], BD: [23.7, 90.4], ID: [-0.8, 113.9], MY: [4.2, 101.9],
  SG: [1.35, 103.8], TH: [15.9, 100.9], VN: [14.1, 108.3], PH: [12.9, 121.8],
  TW: [23.7, 121.0], HK: [22.3, 114.2], LK: [7.9, 80.8], NP: [28.4, 84.1],
  KZ: [48.0, 66.9], UZ: [41.4, 64.6], MM: [21.9, 95.96],
  AE: [23.4, 53.8], SA: [23.9, 45.1], IL: [31.0, 34.9], QA: [25.4, 51.2],
  KW: [29.3, 47.5], JO: [30.6, 36.2], LB: [33.9, 35.9], IQ: [33.2, 43.7],
  IR: [32.4, 53.7], OM: [21.5, 55.9], BH: [26.0, 50.5], YE: [15.6, 48.5],
  ZA: [-30.6, 22.9], EG: [26.8, 30.8], NG: [9.1, 8.7], KE: [-0.02, 37.9],
  MA: [31.8, -7.1], DZ: [28.0, 1.7], TN: [33.9, 9.6], GH: [7.9, -1.0],
  ET: [9.1, 40.5], TZ: [-6.4, 34.9], UG: [1.4, 32.3], AO: [-11.2, 17.9],
  CI: [7.5, -5.5], CM: [7.4, 12.4], ZM: [-13.1, 27.8], ZW: [-19.0, 29.2],
  SN: [14.5, -14.5], LY: [26.3, 17.2],
  AU: [-25.3, 133.8], NZ: [-40.9, 174.9],
};
